import { useCallback, useState } from "react";
import DialogCriacaoEditDepartamentos from "./DialogCriacaoEditDepartamentos";
import { IDataDepartamentosFinanceiros } from "../../../../../types/api/financeiro/pesquisar-departamentos-financeiros";
import SessaoConfiguracao, { ConfiguracaoColunas } from "../../../../../components/BasicComponents/DisplayDados/SessaoConfiguracao";

export default function Departamentos() {

    const [openModal, setOpenModal] = useState<TOpenModalDepartamentosFinanceiros>(null)

    //funções manipuladoras
    const handleModalAction = useCallback((action: "open" | "close", id?: true | number, value?: IDataDepartamentosFinanceiros | null) => {
        if (action === "close") setOpenModal(null)
        if (action === "open" && id && value) setOpenModal({ open: id, defaultValue: value })
        if (action === "open" && id && !value) setOpenModal({ open: id, defaultValue: null })

    }, [])
    //

    return (
        <>
            <SessaoConfiguracao<IDataDepartamentosFinanceiros>
                titulo="Departamentos"
                endpoints={{
                    listar: "financeiro/configuracoes/pesquisar-departamentos",
                    deletar: "financeiro/configuracoes/excluir-departamento",
                }}
                colunas={colunas}
                queryKey="pesquisar-departamentos"
                onEditar={(departamento) => {
                    handleModalAction("open", departamento.id, departamento)
                }}
                onAdicionar={() => {
                    handleModalAction("open", true, null)
                }}
                mensagemSucessoDeletar="Departamento deletado com sucesso!"
                mensagemErroDeletar="Erro ao deletar departamento!"
                mensagemSemDados="Nenhum departamento encontrado."
            />

            {
                Boolean(openModal?.open) &&
                <DialogCriacaoEditDepartamentos
                    defaultValue={openModal?.defaultValue ? openModal : null}
                    open={Boolean(openModal?.open)}
                    handleClose={() => handleModalAction("close")}
                />
            }

        </>
    )
}

export type TOpenModalDepartamentosFinanceiros = {
    open: number | boolean | null;
    defaultValue: IDataDepartamentosFinanceiros | null;
} | null

const colunas: ConfiguracaoColunas<IDataDepartamentosFinanceiros>[] = [
    {
        campo: "id",
        titulo: "Código",
    },
    {
        campo: "nome",
        titulo: "Nome",
    }
];
